export { VehicleDynamicWireframe } from './VehicleDynamicWireframe';
export { type VehicleDynamicWireframeProps } from './hooks';
